import { LoginForm } from '../components/LoginForm';
import { Typography } from 'antd';
const { Title } = Typography;

export const Login = () => {
  return <div>
    <Title style={{ textAlign: 'center' }} level={1}> Login </Title>
    <LoginForm />
  </div>
}